import React, { useState, useEffect } from 'react';
import axios from 'axios';
import base from '../../config';
import SettingsIcon from '@material-ui/icons/Settings';

const MaintenanceBanner = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Initial check
    checkMaintenance();

    // Listen for maintenance status updates from auth flow
    const handleMaintenanceUpdate = (event) => {
      setShow(event.detail.maintenance_active);
      setMessage(event.detail.message);
    };

    window.addEventListener('maintenanceStatusUpdate', handleMaintenanceUpdate);

    // Check every 5 minutes as fallback
    const interval = setInterval(checkMaintenance, 300000);

    return () => {
      clearInterval(interval);
      window.removeEventListener('maintenanceStatusUpdate', handleMaintenanceUpdate);
    };
  }, []);

  const checkMaintenance = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        // No token yet, silently return
        return;
      }

      const response = await axios.get(`${base.urls.apis.details}/maintenance-status`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setShow(response.data.maintenance_active);
      setMessage(response.data.message || 'System maintenance in progress. Orders may be delayed.');
    } catch (error) {
      // console.log('Maintenance status check failed:', error);
      // Don't hide banner on auth errors during login process
      if (error.response && error.response.status !== 401) {
        setShow(false);
      }
    }
  };

  return (
    <>
      {show && (
        <>
          <div style={{
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        width: '100%',
        background: 'linear-gradient(135deg, #0B0614 0%, #1A0B2E 50%, #0B0614 100%)',
        color: 'white',
        padding: '16px 24px',
        boxShadow: '0 4px 20px rgba(161, 0, 255, 0.15), 0 0 40px rgba(161, 0, 255, 0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '2px solid #A100FF',
        boxSizing: 'border-box',
        overflow: 'hidden',
        zIndex: 1300 // Higher than headers (1100) but not too high
      }}>
      <div style={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
        <div style={{
          width: '36px',
          height: '36px',
          backgroundColor: 'rgba(161, 0, 255, 0.2)',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '16px',
          flexShrink: 0,
          border: '1px solid rgba(161, 0, 255, 0.3)'
        }}>
          <SettingsIcon style={{ fontSize: '18px', color: '#A100FF' }} />
        </div>

        {/* Content section */}
        <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
          <div style={{
            fontSize: '15px',
            fontWeight: '600',
            marginBottom: '4px',
            letterSpacing: '0.5px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'white'
          }}>
            SYSTEM MAINTENANCE NOTICE
          </div>
          <div style={{
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '1.4',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            wordWrap: 'break-word',
            overflow: 'hidden',
            color: 'rgba(255, 255, 255, 0.85)'
          }}>
            {message}
          </div>
        </div>
      </div>
      </div>

          {/* Spacer to push content below the fixed banner */}
          <div style={{
            height: '75px', // Approximate height of the banner (padding + content + border)
            width: '100%'
          }} />
        </>
      )}
    </>
  );
};

export default MaintenanceBanner;